import axios from 'axios'
import { useTranslation } from "react-i18next"
import { Link, useNavigate } from "react-router-dom"
import { Fragment, useState, useEffect } from "react"
import { Circle, Send, Check, X, ChevronDown, Eye, Edit, RefreshCw } from "react-feather"
import Avatar from "@components/avatar"
import UILoader from "@components/ui-loader"
import Spinner from "@components/spinner/Loading-spinner"
import "@styles/react/apps/app-invoice.scss"
import "@styles/react/libs/tables/react-dataTable-component.scss"
import GetApiCOC from '../../@fake-db/ApiCOC' 
import {
  Button,
  Card,
  CardText,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle,
  Col,
  Modal,
  Row,
  UncontrolledTooltip,
  Table,
  Label,
  Input
} from "reactstrap"
import { getUserData } from "../../auth/utils"
import FormConfirm from "./FormConfirm"

const base64ToString = (response) => { 
  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
} 

const ModalClosureAll = ({ formAdd, setFormAdd }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const user = getUserData()

  const [dataStore, setDataStore] = useState(JSON.parse(localStorage.getItem("dataAllClosure") || "[]"))

  const [filterValue, setFilterValue] = useState("")
  const [dataFiltrada, setDataFiltrada] = useState(dataStore)
  const [valoresMostrados, setValoresMostrados] = useState(10)
  const [valoreRegistro, setValoreRegistro] = useState(10)
  const [blockAllClosures, setBlockAllClosures] = useState(false)
  const [formConfirm, setFormConfirm] = useState(false)
  
  const nuemeroStore = dataStore.length

  const permisoEditarEx =
    user.permission.find((e) => e.menu_id === "EXEOPT").can_edit === 1
  const permisoVisualizarEx =
    user.permission.find((e) => e.menu_id === "EXEOPT").can_show === 1
  const permisoEditarGe =
    user.permission.find((e) => e.menu_id === "GEROPT").can_edit === 1
  const permisoVisualizarGe =
    user.permission.find((e) => e.menu_id === "GEROPT").can_show === 1
  const permisoVisualizarCo =
    user.permission.find((e) => e.menu_id === "CHAOPT").can_show === 1
  const permisoVisualizarSp =
    user.permission.find((e) => e.menu_id === "PAYOPT").can_show === 1

  const closureStatusObj = {
    100: {
      color: "light-secondary",
      icon: Circle,
      tooltip: "Pendiente Ejecutivo"
    },
    1: {
      color: "light-success",
      icon: Send,
      tooltip: "Finalizado Ejecutivo"
    },
    2: {
      color: "light-primary",
      icon: Check,
      tooltip: "Aprobado Gerente"
    },
    3: {
      color: "light-danger",
      icon: X,
      tooltip: "Declinado"
    }
  }

  useEffect(() => {
    const fetchData = async () => {

      setBlockAllClosures(true)

      const user = getUserData()

      const body = {
        office_id: user.usercoc.office_id,
        user_id  : user.usercoc.user_id,
        role     : user.usercoc.role,
        superuser: user.usercoc.superuser
      }

      const configws = {
        method: 'post',
        url: GetApiCOC('getAllClosure'),
        headers: {
          Accept: 'application/json',
          obrientoken: user.token
        },
        params: body
      }

      try {
        const response = await axios(configws)
        const data = base64ToString(response)
        const reducedData = data.map(item => ({
          id_closure      : item.id_closure,
          id_closure_coc1 : item.id_closure_coc1,
          user_closure    : item.user_closure,
          user_uptake     : item.user_uptake,
          closure_status  : item.closure_status,
          client_name     : item.client_data.name,
          property_data   : item.property_data.address,
          internal_key    : item.property_data.internal_key,
          closure_date    : item.closure_date
        }))

        setDataStore(reducedData)
        setDataFiltrada(reducedData)
        localStorage.setItem('dataAllClosure', JSON.stringify(reducedData))
        console.log('dataAllClosure success')
      } catch (error) {
        console.log('Error', error.message)
      }

      setBlockAllClosures(false)
    }

    if (dataStore.length === 0) {
      fetchData()
    }
  }, [])


  const applyFilter = () => {

    setBlockAllClosures(true)

    const queryLowered = filterValue.toLowerCase()
    if (queryLowered === "") {
      setValoresMostrados(10)
    } else {
      setValoresMostrados(nuemeroStore)
    }

    const filteredData = dataStore.filter(closure => {

      return (
        (
          (closure.id_closure && String(closure.id_closure).toLowerCase().includes(queryLowered)) ||
          (closure.id_closure_coc1 && String(closure.id_closure_coc1).toLowerCase().includes(queryLowered)) ||
          (closure.client_name && String(closure.client_name).toLowerCase().includes(queryLowered)) ||
          (closure.property_data && String(closure.property_data).toLowerCase().includes(queryLowered)) ||
          (closure.user_closure && String(closure.user_closure).toLowerCase().includes(queryLowered)) ||
          (closure.user_uptake && String(closure.user_uptake).toLowerCase().includes(queryLowered)) ||
          (closure.user_uptake && String(closure.user_uptake).toLowerCase().includes(queryLowered)) ||
          (closure.internal_key && String(closure.internal_key).toLowerCase().includes(queryLowered)) ||
          (closure.closure_date && String(closure.closure_date).toLowerCase().includes(queryLowered))
        ) 
      )
  })

  setDataFiltrada(filteredData)
  const filtroNumero = filteredData.length
  
  if (queryLowered === "") {
    setValoreRegistro(10)
  } else {
    setValoreRegistro(filtroNumero)
  }

  setBlockAllClosures(false)

  }

  const onClickButton = async () => {
    setFormConfirm(true)
  }

  const statusIcon = (id, status) => {
    const estado = closureStatusObj[status]
    const Icon = estado.icon

    return (
      <Fragment>
        <Avatar color={estado.color} icon={<Icon size={14} />} id={`av-tooltip-${id}`} />
        <UncontrolledTooltip placement="top" target={`av-tooltip-${id}`}>
          <span className="fw-bold">{estado.tooltip}</span>
        </UncontrolledTooltip>
      </Fragment>
    )
  }

  const MuestraEditarEx = (closure_status) => {
    return permisoEditarEx && closure_status === 100
  }

  const MuestraPreviewEx = (closure_status) => {
    return permisoVisualizarEx && (closure_status === 100 || closure_status === 1 || closure_status === 2)
  }

  const MuestraEditarGe = (closure_status) => {
    return permisoEditarGe && closure_status === 1
  }

  const MuestraPreviewGe = (closure_status) => {
    return permisoVisualizarGe && (closure_status === 2 || closure_status === 1)
  }

  const MuestraPreviewCo = (closure_status) => {
    return permisoVisualizarCo && closure_status === 2
  }

  const MuestraPreviewSp = (closure_status) => {
    return permisoVisualizarSp && closure_status === 2
  }

  const handleClickExEdi = (id_closure) => {
    navigate(`/closures/executive/edit/${id_closure}`)
    setFormAdd(false)
  }

  const handleClickExPrev = (id_closure) => {
    navigate(`/closures/executive/preview/${id_closure}`)
    setFormAdd(false)
  }

  const handleClickGeEdi = (id_closure) => {
    navigate(`/closures/manager/edit/${id_closure}`)
    setFormAdd(false)
  }

  const handleClickGePrev = (id_closure) => {
    navigate(`/closures/manager/preview/${id_closure}`)
    setFormAdd(false)
  }

  const handleClickCo = (id_closure) => {
    navigate(`/closures/charge/preview/${id_closure}`)
    setFormAdd(false)
  }

  const handleClickSp = (id_closure) => {
    navigate(`/closures/payment/preview/${id_closure}`)
    setFormAdd(false)
  }

  const renderData = () => {
    return dataFiltrada.slice(0, valoresMostrados).map((col) => {
      return (
        <tr key={`Tabla_closure-${col.id_closure}`}>
          <td>
            COC1:
            <br></br>
            {col.id_closure}
            <br></br>
            Obrien:
            <br></br>
            {col.id_closure_coc1}
          </td>
          <td>
            {statusIcon(col.id_closure, col.closure_status)}
          </td>
          <td>
            {col.closure_date}
          </td>
          <td style={{ whiteSpace: "normal" }} className="text-wrap px-1">
            {col.client_name}
          </td>
          <td style={{ whiteSpace: "normal" }} className="text-wrap px-1">
            {col.property_data}
          </td>
          <td className="text-wrap px-1">
            {col.user_closure}
          </td>
          <td className="text-wrap px-1">
            {col.user_uptake}
          </td>
          <td className="text-wrap px-1">
            <div className="column-action d-flex align-items-center">
              {MuestraPreviewEx(col.closure_status) && (
                <a onClick={() => handleClickExPrev(col.id_closure)} id={`pw-tooltip-ex-prev${col.id_closure}`}>
                  <Eye className="cursor-pointer" size={17} id={`det-tooltip-ex-prev${col.id_closure}`} />
                  <UncontrolledTooltip placement="top" target={`det-tooltip-ex-prev${col.id_closure}`}>
                    Ver Ejecutivo
                  </UncontrolledTooltip>
                </a>
              )}
              {MuestraEditarEx(col.closure_status) && (
                <a className="cursor-pointer mx-1" onClick={() => handleClickExEdi(col.id_closure)} id={`pw-tooltip-ex-edit${col.id_closure}`}>
                  <Edit className="cursor-pointer" size={17} id={`edit-tooltip-ex-edit${col.id_closure}`} />
                  <UncontrolledTooltip placement="top" target={`edit-tooltip-ex-edit${col.id_closure}`}>
                    Editar Ejecutivo
                  </UncontrolledTooltip>
                </a>
              )}
            </div>
          </td>
          <td className="text-wrap px-1">
            <div className="column-action d-flex align-items-center">
              {MuestraPreviewGe(col.closure_status) && (
                <a onClick={() => handleClickGePrev(col.id_closure)} id={`pw-tooltip-ge-prev${col.id_closure}`}>
                  <Eye className="cursor-pointer" size={17} id={`det-tooltip-ge-prev${col.id_closure}`} />
                  <UncontrolledTooltip placement="top" target={`det-tooltip-ge-prev${col.id_closure}`}>
                    Ver Gerente
                  </UncontrolledTooltip>
                </a>
              )}
              {MuestraEditarGe(col.closure_status) && (
                <a className="cursor-pointer mx-1" onClick={() => handleClickGeEdi(col.id_closure)} id={`pw-tooltip-ge-edit${col.id_closure}`}>
                  <Edit className="cursor-pointer" size={17} id={`edit-tooltip-ge-edit${col.id_closure}`} />
                  <UncontrolledTooltip placement="top" target={`edit-tooltip-ge-edit${col.id_closure}`}>
                    Editar Gerente
                  </UncontrolledTooltip>
                </a>
              )}
            </div>
          </td>
          <td className="text-wrap px-1">
            <div className="column-action d-flex align-items-center">
              {MuestraPreviewCo(col.closure_status) && (
                <a onClick={() => handleClickCo(col.id_closure)} id={`pw-tooltip-co-prev${col.id_closure}`}>
                  <Eye className="cursor-pointer" size={17} id={`det-tooltip-co-prev${col.id_closure}`} />
                  <UncontrolledTooltip placement="top" target={`det-tooltip-co-prev${col.id_closure}`}>
                    Ver Cobros
                  </UncontrolledTooltip>
                </a>
              )}
            </div>
          </td>
          <td className="text-wrap px-1">
            <div className="column-action d-flex align-items-center">
              {MuestraPreviewSp(col.closure_status) && (
                <a onClick={() => handleClickSp(col.id_closure)} id={`pw-tooltip-sp-prev${col.id_closure}`}>
                  <Eye className="cursor-pointer" size={17} id={`det-tooltip-sp-prev${col.id_closure}`} />
                  <UncontrolledTooltip placement="top" target={`det-tooltip-sp-prev${col.id_closure}`}>
                    Ver Hojas de Servicios
                  </UncontrolledTooltip>
                </a>
              )}
            </div>
          </td>
        </tr>
      )
    })
  }

  return (

    <Fragment>
    <Modal isOpen={formAdd} className="modal-dialog modal-dialog-centered modal-xl">
      <div className="invoice-list-wrapper">
        <Card className="mt-1 me-1 ms-1">
          <UILoader blocking={blockAllClosures} loader={<Spinner />}>
            <CardHeader>
              <Row>
                <Col className="d-flex align-items-center justify-content-center">
                  <Label className="pe-1">Buscar: </Label>
                  <Input onChange={(e) => setFilterValue(e.target.value)} className="me-1"></Input>
                  <Button onClick={() => applyFilter()}>Buscar</Button>
                  <div className="ps-1">
                    <Button onClick={onClickButton} style={{ padding: '6px', fontSize: '20px' }}>
                      <RefreshCw style={{ width: '15px' }} />
                    </Button>
                  </div>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <div style={{ maxHeight: "700px", maxWidth: "100%", overflowX: 'auto' }}>
                <Table className="ps-0 pe-0 table-sm">
                  <thead>
                    <tr>
                      <th ClassName="px-1">#</th>
                      <th ClassName="px-1">{t("Estado")}</th>
                      <th ClassName="px-1">{t("Fecha")}</th>
                      <th ClassName="px-1">{t("Nombre")}</th>
                      <th ClassName="px-1">{t("Propiedad")}</th>
                      <th ClassName="px-1">{t("Cerrador")}</th>
                      <th ClassName="px-1">{t("Captor")}</th>
                      <th ClassName="px-1">{t("Ejecutivo")}</th>
                      <th ClassName="px-1">{t("Gerente")}</th>
                      <th ClassName="px-1">{t("Cobro Cier")}</th>
                      <th ClassName="px-1">{t("Serv Pro")}</th>
                    </tr>
                  </thead>
                  <tbody>{renderData()}</tbody>
                </Table>
              </div>
            </CardBody>
          </UILoader>
          <CardFooter className="text-center">
            <Label className="">Tomar en cuenta que si la búsqueda no es específica, la respuesta del servicio puede tardar más tiempo. Por favor, utiliza la búsqueda para ver otros registros.</Label>
            <div className="d-flex align-items-center justify-content-center">
              <h4 className="me-2">{valoreRegistro}</h4>
              <Label className="me-2">De</Label>
              <h4>{nuemeroStore}</h4>
            </div>
            <Button onClick={() => setFormAdd(false)}>Cerrar</Button>
          </CardFooter>
        </Card>
      </div>
    </Modal>
    <FormConfirm formConfirm={formConfirm} setFormConfirm={setFormConfirm} setBlockAllClosures={setBlockAllClosures}></FormConfirm>
    </Fragment>
  )
}

export default ModalClosureAll
